export default "__VITE_ASSET__CJ6ARqrA__"